/**
 * Created by Timur on 21.08.2026
 */

const Merge2MissionComponentsFactory = {
    create: function (unit, data) {
        const stageConfig = Merge2MissionFamilies.getStageConfig(unit.code, unit.stage);
        const components = [new Merge2MissionMergeComponent(unit)];

        if (data && data.grounded !== undefined) {
            components.push(new Merge2MissionGroundedComponent(unit, data.grounded));
        }

        if (stageConfig.generator) {
            components.push(new Merge2MissionGeneratorComponent(unit, stageConfig.generator, data));
        }

        if (stageConfig.type === Merge2MissionFamilies.TYPE.CUSTOMER) {
            components.push(new Merge2MissionCustomerComponent(unit, stageConfig.orders, data));
        }

        return components;
    }
};
